import {
  fetchLessonClass,
  fetchLessonClassStudents,
} from "classroom/api/teacher";
import type { ClassroomLessonClass, ClassroomStudent } from "classroom/types";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useClassroomLessonClassStore = defineStore(
  "classroomLessonClass",
  () => {
    const lessonClass = ref<ClassroomLessonClass | null>(null);
    const students = ref<ClassroomStudent[] | null>(null);
    const allStudents = ref<ClassroomStudent[] | null>(null);

    const loadLessonClass = async (
      scheduleId: string,
      signal?: AbortSignal,
    ): Promise<void> => {
      lessonClass.value = await fetchLessonClass(scheduleId, signal);
    };

    const loadStudents = async (
      scheduleId: string,
      search: string | null = null,
      signal?: AbortSignal,
    ): Promise<void> => {
      students.value = await fetchLessonClassStudents(
        scheduleId,
        search,
        signal,
      );
    };

    // Unfiltered class list for the page header; `students` stays owned by
    // the students tab, which overwrites it with search-filtered results.
    const loadAllStudents = async (
      scheduleId: string,
      signal?: AbortSignal,
    ): Promise<void> => {
      allStudents.value = await fetchLessonClassStudents(
        scheduleId,
        null,
        signal,
      );
    };

    const reset = (): void => {
      lessonClass.value = null;
      students.value = null;
      allStudents.value = null;
    };

    return {
      lessonClass,
      students,
      allStudents,
      loadLessonClass,
      loadStudents,
      loadAllStudents,
      reset,
    };
  },
);
